module.exports = __webpack_public_path__ + "img/C08TechAshokasWrath_ua.d6406fea.webp";